<h1 ev-dialog-title data-testid="history-dialog-title">{{ languageService.languageJSON.Global_History }}</h1>

<div ev-dialog-content data-testid="history-dialog-container">
  <!-- LOADER -->
  @if (historyLoader()) {
    <div class="dialog-loader-outer">
      <app-ev-loader></app-ev-loader>
    </div>
  }

  <div class="history-content">

    <!-- CAR SELECTOR -->
    <div class="user-car-selector-row">
      <app-user-vehicles-selector [historySelector]="true" (valueChange)="setSelectedUserVehicle($event)">
      </app-user-vehicles-selector>
    </div>

    <!-- EMPTY STATE -->
    @if (historyLoaded() && !historyLoader() && historyList().length === 0) {
      <div class="history-empty" data-testid="history-dialog-empty-container">
        <div class="history-empty__icon">
          <img [src]="'assets/icons/' + settingsService.getMap().Skin + '/ui/menu_icon_history.svg'" alt="" />
        </div>
        <p class="history-empty__title">{{ languageService.languageJSON.HistoryDialog_Empty_Title }}</p>
        <p class="history-empty__desc">{{ languageService.languageJSON.HistoryDialog_Empty_Desc }}</p>
      </div>
    }

    <!-- HISTORIES -->
    <div class="history-stack scrollable" data-testid="history-dialog-list-container">
      @for (historyGroup of historyGroups(); track historyGroup; let gi = $index) {
        <div class="history-group" [class.opened]="historyGroup.opened">
          <button type="button" class="history-group__header"
            [attr.data-testid]="'history-dialog-group-header-btn-' + gi"
            (click)="toggleHistoryGroup(gi)">
            <span class="history-group__date">{{ historyGroup.date | date:'shortDate' }}</span>
            <span class="history-group__opener" [class.opened]="historyGroup.opened">
              <img src="assets/icons/default/ui/dropdown_triangle.svg" alt="" />
            </span>
          </button>

          <div class="history-group__body" [class.opened]="historyGroup.opened">
            @for (historyItem of historyGroup.trips; track historyItem; let ti = $index) {
              <div class="history-trip">
                <!-- Covers the whole card so any click on it opens the trip; a native button
                     can't wrap the card because the card contains the remove button. -->
                <button type="button" class="ev-plain-button history-trip__open"
                  [attr.data-testid]="'history-dialog-trip-' + gi + '-' + ti"
                  [attr.aria-label]="historyItem.startLocation + ' - ' + historyItem.targetLocation"
                  (click)="openRouteHistoryOnMap(historyItem)"></button>
                <div class="history-trip__header">
                  <div class="history-trip__title">
                    <p>{{ historyItem.startLocation }} - {{ historyItem.targetLocation }}</p>
                    <p>{{ historyItem.startTime | date }}</p>
                  </div>
                  <button type="button" class="history-trip__remove"
                    [attr.data-testid]="'history-dialog-trip-remove-btn-' + gi + '-' + ti"
                    (click)="removeHistoryElement($event, historyItem)">
                    <img src="/assets/icons/dark/ui/deletetrack_icon.svg" alt="" />
                  </button>
                </div>

                <div class="history-trip__stats">
                  <div class="stat-pill">
                    <img class="stat-pill__icon" alt="distance"
                      [src]="'assets/icons/light/ui/vehicle_settings_icon_range.svg'" />
                    <span class="stat-pill__value" [hidden]="settingsService.getUnit().Distance!='metric'">
                      {{ historyItem.distance }} km
                    </span>
                    <span class="stat-pill__value" [hidden]="settingsService.getUnit().Distance!='imperial'">
                      {{ (historyItem.distance * 6.21371192)/10 | turnValueIntegerThousands }} mi
                    </span>
                  </div>

                  <div class="stat-pill">
                    <img class="stat-pill__icon" alt="total time"
                      [src]="'assets/icons/light/ui/trip_icon_total_time.svg'" />
                    <span class="stat-pill__value stat-pill__value--time">
                      @if (historyItem.totalTime.h) {
                        <span>
                          {{ historyItem.totalTime.h }}{{ languageService.languageJSON.Unit_Hour_Short }}
                          {{ historyItem.totalTime.i }} {{ languageService.languageJSON.Unit_Minute_Short }}
                        </span>
                      }
                      @if (!historyItem.totalTime.h) {
                        <span>
                          {{ historyItem.totalTime.i }} {{ languageService.languageJSON.Unit_Minute_Short }}
                        </span>
                      }
                    </span>
                  </div>

                  <div class="stat-pill">
                    <img class="stat-pill__icon" alt="capacity"
                      [src]="'assets/icons/light/ui/vehicle_settings_icon_capacity.svg'" />
                    <span class="stat-pill__value" [hidden]="settingsService.getUnit().Distance!='metric'">
                      {{ historyItem.avgConsumption }} kWh/100km
                    </span>
                    <span class="stat-pill__value" [hidden]="settingsService.getUnit().Distance!='imperial'">
                      {{ (historyItem.avgConsumption * 16.09344)/10 | turnValueIntegerThousands }} kWh/100mi
                    </span>
                  </div>

                  <div class="stat-pill">
                    <img class="stat-pill__icon" alt="consumption"
                      [src]="'assets/icons/light/ui/trip_icon_total_consumption.svg'" />
                    <span class="stat-pill__value">{{ historyItem.totalConsumption }} kWh</span>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      }

      @if (historyList().length > 0) {
        <div class="history-delete-all">
          <button type="button" class="ev-button" data-testid="history-dialog-delete-all-btn" (click)="removeAllHistoryElement()">
            {{ languageService.languageJSON.HistoryDialog_DeleteAllTrip }}
          </button>
        </div>
      }
    </div>
  </div>
</div>

<div ev-dialog-actions>
  <button class="ev-button primary" name="close_button" mat-button data-testid="history-dialog-close-btn" (click)="close()">
    {{ languageService.languageJSON.Global_Close }}
  </button>
</div>
